export class BlacklistVin {
    id: number;
    vin: string;
    dateCreated: string;
}
